module.exports = __webpack_public_path__ + "img/p2p.922d9cdd.webp";